<template>
    <div style="padding: 18px">
    <v-card>
    <v-tabs v-model="tab">
      <v-tab :style="{ textTransform: 'none' }">Bulk Upload Generate QRIS Statis</v-tab>
      <v-tab :style="{ textTransform: 'none' }">History Bulk</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <div class="d-flex justify-center align-center flex-column" :style="{ padding: '10px' }">
              <BulkUpload />
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <HistoryList />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</div>
</template>

<script>
export default {
  components: {
    BulkUpload: () => import('../../components/merchant-tools/generate-bulk/BulkUpload.vue'),
    HistoryList: () => import('../../components/merchant-tools/generate-bulk/HistoryList.vue'),
  },
  data() {
    return {
      tab: 0, 
    };
  },
};
</script>

